import { styled } from "../../Theme";

export const Video = styled.video`
  width: 60%;
  max-width: 60%;
  height: 100%;
  @media (max-width: ${(props) => props.theme.mobileFirst.breakPoint}) {
    width: 100%;
    max-width: 100%;
  }
`;
